// extracted by mini-css-extract-plugin
module.exports = {"link":"Header_link__1QDOU","link_title":"Header_link_title__pUGlW","logo":"Header_logo__3Zybh"};